import { render, staticRenderFns } from "./confirmbill.vue?vue&type=template&id=2da70664"
import script from "./confirmbill.vue?vue&type=script&lang=js"
export * from "./confirmbill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports